import { getState } from '../../reduxService';

/* import * as SelectorMacro1 from '../Macro1/selector/conversion';
import * as ProjectMacro1 from '../Macro1/store/project/projectSlice';
import * as ResultsMacro1 from '../Macro1/store/project/resultsSlice';
import * as TemplateMacro1 from '../Macro1/store/template/templateSlice'; */

/* import * as SelectorMacro2 from '../Macro2/selector/conversion'; */
/* import * as ProjectMacro2 from '../Macro2/store/project/projectSlice'; */
/* import * as ResultsMacro2 from '../Macro2/store/project/resultsSlice';
import * as TemplateMacro2 from '../Macro2/store/template/templateSlice'; */
import * as ProjectMacro1 from '../Macro1/store/project/projectslice';
import InputFormMacro1 from '../Macro1/components/InputForm/InputForm';
import InputFormMacro2 from '../Macro2/components/InputForm/InputForm';
import GraphicMacro1 from '../Macro1/components/Graphic/Graphic';
import ResultsMacro1 from '../Macro1/components/Results/Results';
import * as ProjectMacro2 from '../Macro2/store/project/projectslice';
import GraphicMacro2 from '../Macro2/components/Graphic/Graphic';
import ResultsMacro2 from '../Macro2/components/Results/Results';
/* import InputFormMacro1 from '../Macro1/components/InputForm/InputForm'; */

import { EProjectType } from '../enum/project';

/* import GraphicalResultsMacro1 from '../Macro1/components/graphicalResults/GraphicalResults';
import GraphicalResultsMacro2 from '../Macro2/components/graphicalResults/GraphicalResults'; */

export const getActionByProjectType = (projectType?: EProjectType | string) => {
    let _projectType = projectType ?? getState().projectInfo.data?.projectType ?? EProjectType.Macro1;
    //console.log(projectType);
    return _projectType == EProjectType.Macro1 ? {inputForm: <InputFormMacro1 />, graphic: <GraphicMacro1 horizontalSpacing={5} verticalSpacing={5} />, results: <ResultsMacro1 horizontalSpacing={5} verticalSpacing={5}></ResultsMacro1>, setProject: ProjectMacro1.setProject} : {inputForm: <InputFormMacro2 />, graphic: <GraphicMacro2 horizontalSpacing={5} verticalSpacing={5} />, results: <ResultsMacro2 horizontalSpacing={5} verticalSpacing={5}></ResultsMacro2>, setProject: ProjectMacro2.setProject}
/* _projectType == EProjectType.Macro1
        ? {
              selectTemplate: TemplateMacro1.selectTemplate,
              selectProject: SelectorMacro1.selectProject,
              selectResults: SelectorMacro1.selectResults,
              setProject: ProjectMacro1.setProject,
              cleanGeometry: ProjectMacro1.cleanGeometry,
              fetchAllTemplate: TemplateMacro1.fetchTemplatesByType,
              fetchTemplateById: ProjectMacro1.fetchTemplateById,
              cleanResults: ResultsMacro1.cleanResults,
              cleanProject: ProjectMacro1.cleanProject,
              inputForm: <InputFormMacro1 />,
              graphicalResults: <GraphicalResultsMacro1 />,
          }
        :  {
              selectTemplate: TemplateMacro2.selectTemplate,
              selectProject: SelectorMacro2.selectProject,
              selectResults: SelectorMacro2.selectResults,
              setProject: ProjectMacro2.setProject,
              cleanGeometry: ProjectMacro2.cleanGeometry,
              fetchAllTemplate: TemplateMacro2.fetchTemplatesByType,
              fetchTemplateById: ProjectMacro2.fetchTemplateById,
             cleanResults: ResultsMacro2.cleanResults,
             cleanProject: ProjectMacro2.cleanProject,
              graphicalResults: <GraphicalResultsMacro2 />,
             inputForm: <InputFormMacro2 />
          }; */
};
